define(
	'C3.ShoppingExtensions.PDP.MakeAnOffer.States.View',
	[
		'SCView', 
		'statesDropdown.tpl',
		'Profile.Model',
		//'SC.Configuration',
		'Utils',
		//'Backbone.View'
		],
	function(
		SCViewComponent, 
		statesDropdown_tpl,
		ProfileModel,
		//Configuration,
		Utils,
		//BackboneView
		) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function MakeAnOfferStatesView(options) {
			SCView.call(this);
			this.options = options || {};
			this.template = statesDropdown_tpl;		
		}

		// Inherit parent instance methods.
		MakeAnOfferStatesView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		MakeAnOfferStatesView.prototype.constructor = MakeAnOfferStatesView;

		MakeAnOfferStatesView.prototype.getContext = function() {
			var country =
            this.options.selectedCountry && this.options.countries[this.options.selectedCountry];
	        var states = country && country.states;
	        var self = this;

	         var profile = ProfileModel.getInstance()
			,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'


	        var selectedStateName= ''

	        _.each(states, function(state) {
	           // state.isSelected = state.code === self.options.selectedState;
	        	if(state.code == self.options.selectedState){
            		selectedStateName = state.name
            	}
	        });
	        
			return {
				isCountryAndStatePresent: !!(country && states),
	            // @property {String} manage
	            manage: this.options.manage || '',
	            // @property {Array<Object>} sates
	            states: states,
	            // @property {String} selectedState
	            selectedState: this.options.selectedState,
	            selectedStateName : selectedStateName,
	            hasDefaultState : selectedStateName ? true : false,
	            isLoggedIn : is_logged_in
			}
		}

		// Return the AMD constructor.
		return MakeAnOfferStatesView;
	}
);
